import React from 'react';

import { slide as Menu } from 'react-burger-menu';
import { Link, NavLink, useHistory } from 'react-router-dom';

import './header.scss';
import '../../theme/vertical-menu.scss';
import logo from '../../images/logo.svg';
import { Space } from '../../components/utils/utils';
import { IoIosMenu, IoMdClose, IoIosArrowDown } from 'react-icons/io';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux';
import { ROUTES } from '../../routing/routes';
import { loginAPI } from '../../network/routes';
import { Types, types_users } from '../../types/users';
import { logout_req } from '../../network/session';
import { getPair } from '../../localStorage';
import {
  API,
  useGetCurrentUserQuery,
  useGetSubordinateInstitutionsQuery,
  useLogoutMutation
} from '../../api';
import { logout } from '../../redux/reducers/session';
import { TagTypes } from '../../api/apiBase.types';
import { current } from '@reduxjs/toolkit';
interface IHeader {}

const Header = (props: IHeader) => {
  const [isOpen, setOpenedMenu] = React.useState(false);
  const [hiddenMenu, setHiddenMenu] = React.useState(false);
  const [internalAdminMenu, setInternalMenu] = React.useState(false);
  const [internalLitigatonsMenu, setInternalLitigatonsMenu] =
    React.useState(false);
  const [internalCcrReportsMenu, setInternalCcrReportsMenu] =
    React.useState(false);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const session = useAppSelector((state: RootState) => state.session.auth);
  const role = useAppSelector((state: RootState) => state.session.role);
  const institutions = useAppSelector(
    (state: RootState) => state.session.institutions
  );
  const { data: currentUser } = useGetCurrentUserQuery();
  const { data: subordonateInstitutions } =
    useGetSubordinateInstitutionsQuery();

  const pair = getPair();

  const handleOpenMenu = (state: any) => {
    setOpenedMenu(state.isOpen);
  };

  const [logoutUserAction] = useLogoutMutation();

  const handleLogout = () => {
    dispatch(logout());
    logoutUserAction();
    dispatch(API.util.invalidateTags([TagTypes.CurrentSession]));
    dispatch(API.util.invalidateTags([TagTypes.CurrentUser]));
    dispatch(API.util.resetApiState());
    history.push(ROUTES.ACCOUNTS);
  };

  return (
    <header>
      {!role && !session && (
        <>
          <div className='vertical-menu'>
            <Menu
              noOverlay
              customBurgerIcon={<IoIosMenu />}
              customCrossIcon={<IoMdClose />}
              isOpen={isOpen}
              onStateChange={handleOpenMenu}
            >
              <>
                <Link to={ROUTES.LOGIN} className='call-to-action'>
                  Autentificare
                </Link>

                <Space vertical={'20vh'} />
                <Link to='/'>
                  <img src={logo} alt='logo_sirar' />
                </Link>
              </>
            </Menu>
          </div>
          <NavLink to='/' className='logo-page'>
            <img src={logo} alt='logo_sirar' />
          </NavLink>

          <Link to={ROUTES.LOGIN} className='call-to-action'>
            Autentificare
          </Link>
        </>
      )}
      {role === types_users.principal && (
        <>
          <div className='vertical-menu'>
            <Menu
              noOverlay
              customBurgerIcon={<IoIosMenu />}
              customCrossIcon={<IoMdClose />}
              isOpen={isOpen}
              onStateChange={handleOpenMenu}
            >
              {session && (
                <div className='mobileNavWrapper'>
                  <div className='mobileNav'>
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.TUTORIAL}
                    >
                      Tutorial
                    </NavLink>
                    <Space vertical={'2vh'} />
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.LITIGII}
                    >
                      Gestionare litigii
                    </NavLink>
                    <Space vertical={'2vh'} />
                    <NavLink to={ROUTES.LITIGATION_NOTIFICATIONS}>
                      Notificari Litigii
                    </NavLink>
                    <Space vertical={'2vh'} />

                    <NavLink to={ROUTES.CALENDAR}>Calendar termene</NavLink>
                    <Space vertical={'2vh'} />
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.REPORTS}
                    >
                      {!currentUser?.institution.private
                        ? 'Rapoarte de control'
                        : 'Rapoarte de control / Contracte'}
                    </NavLink>
                    <Space vertical={'2vh'} />
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.DECISIONS}
                    >
                      Monitorizări
                    </NavLink>
                    <Space vertical={'2vh'} />
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.NOTIFICATIONS}
                    >
                      Notificări
                    </NavLink>
                    <Space vertical={'2vh'} />

                    {!currentUser?.institution.private && (
                      <>
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.AUDITS_NOTIFICATIONS}
                        >
                          Audit Curte Conturi
                        </NavLink>
                        <Space vertical={'2vh'} />
                      </>
                    )}
                    {!currentUser?.institution.private && (
                      <>
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.LEGISLATION}
                        >
                          Legislație
                        </NavLink>
                        <Space vertical={'2vh'} />
                      </>
                    )}
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.ACCOUNTS}
                    >
                      Conturi
                    </NavLink>
                    <Space vertical={'2vh'} />
                    {!currentUser?.institution.private && (
                      <>
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.ACHIZITII}
                        >
                          Achiziții publice
                        </NavLink>
                        <Space vertical={'2vh'} />
                      </>
                    )}
                    {!currentUser?.institution.private && (
                      <>
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.INSTITUTION}
                        >
                          Instituție
                        </NavLink>
                        <Space vertical={'2vh'} />
                      </>
                    )}
                    {subordonateInstitutions?.data?.length > 0 && (
                      <>
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.ADMIN_REPORTS}
                        >
                          Administrare rapoarte
                        </NavLink>
                        <Space vertical={'2vh'} />
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.ADMIN_DECISIONS}
                        >
                          Administrare monitorizari
                        </NavLink>
                      </>
                    )}
                  </div>
                  <a onClick={handleLogout} className='logout last'>
                    Ieșire
                  </a>
                </div>
              )}
              {!session && (
                <>
                  <Link to={ROUTES.LOGIN} className='call-to-action'>
                    Autentificare
                  </Link>

                  <Space vertical={'20vh'} />
                  <Link to='/'>
                    <img src={logo} alt='logo_sirar' />
                  </Link>
                </>
              )}
            </Menu>
          </div>
          <NavLink to='/' className='logo-page'>
            <img src={logo} alt='logo_sirar' />
          </NavLink>

          {session && (
            <>
              <nav>
                <NavLink activeClassName='activeLink' to={ROUTES.TUTORIAL}>
                  Tutorial
                </NavLink>
                <Space vertical={'2vh'} />
                <div
                  className='submenu'
                  onMouseEnter={() => setInternalLitigatonsMenu(true)}
                  onMouseLeave={() => setInternalLitigatonsMenu(false)}
                >
                  <p className='label'>
                    Litigii <IoIosArrowDown />
                  </p>
                  <div
                    className='list'
                    style={{
                      display: !internalLitigatonsMenu ? 'none' : 'flex'
                    }}
                  >
                    <NavLink activeClassName='activeLink' to={ROUTES.LITIGII}>
                      Gestionare Litigii
                    </NavLink>
                    <NavLink
                      activeClassName='activeLink'
                      to={ROUTES.LITIGATION_NOTIFICATIONS}
                    >
                      Notificari
                    </NavLink>
                    <NavLink activeClassName='activeLink' to={ROUTES.CALENDAR}>
                      Calendar termene
                    </NavLink>
                  </div>
                </div>
                <Space vertical={'2vh'} />
                <div
                  className='submenu'
                  onMouseEnter={() => setInternalCcrReportsMenu(true)}
                  onMouseLeave={() => setInternalCcrReportsMenu(false)}
                >
                  <p className='label'>
                    {!currentUser?.institution.private
                      ? 'Rapoarte de control'
                      : 'Rapoarte de control / Contracte'}
                    <IoIosArrowDown />
                  </p>
                  <div
                    className='list'
                    style={{
                      display: !internalCcrReportsMenu ? 'none' : 'flex'
                    }}
                  >
                    <NavLink activeClassName='activeLink' to={ROUTES.REPORTS}>
                      {!currentUser?.institution.private
                        ? 'Rapoarte de control'
                        : 'Rapoarte de control / Contracte'}
                    </NavLink>
                    <NavLink activeClassName='activeLink' to={ROUTES.DECISIONS}>
                      Monitorizari
                    </NavLink>
                    <NavLink
                      activeClassName='activeLink'
                      to={ROUTES.NOTIFICATIONS}
                    >
                      Notificari
                    </NavLink>
                    {!currentUser?.institution.private && (
                      <NavLink
                        activeClassName='activeLink'
                        to={ROUTES.AUDITS_NOTIFICATIONS}
                      >
                        Audit Curte Conturi
                      </NavLink>
                    )}
                  </div>
                </div>
                <Space vertical={'2vh'} />
                {!currentUser?.institution.private && (
                  <>
                    <NavLink
                      activeClassName='activeLink'
                      to={ROUTES.LEGISLATION}
                    >
                      Legislație
                    </NavLink>
                    <Space vertical={'2vh'} />
                  </>
                )}
                <div
                  className='submenu'
                  onMouseEnter={() => setInternalMenu(true)}
                  onMouseLeave={() => setInternalMenu(false)}
                >
                  <p className='label'>
                    Administrare internă <IoIosArrowDown />
                  </p>
                  <div
                    className='list'
                    style={{ display: !internalAdminMenu ? 'none' : 'flex' }}
                  >
                    {!currentUser?.institution.private && (
                      <NavLink
                        activeClassName='activeLink'
                        to={ROUTES.ACHIZITII}
                      >
                        Achiziții publice
                      </NavLink>
                    )}
                    <NavLink activeClassName='activeLink' to={ROUTES.ACCOUNTS}>
                      Conturi
                    </NavLink>
                    {!currentUser?.institution.private && (
                      <NavLink
                        activeClassName='activeLink'
                        to={ROUTES.INSTITUTION}
                      >
                        Instituție
                      </NavLink>
                    )}
                  </div>
                </div>
                {subordonateInstitutions?.data?.length > 0 && (
                  <div
                    className='submenu'
                    onMouseEnter={() => setHiddenMenu(true)}
                    onMouseLeave={() => setHiddenMenu(false)}
                  >
                    <p className='label'>
                      Administrare institutii <IoIosArrowDown />
                    </p>

                    <div
                      className='list'
                      style={{ display: !hiddenMenu ? 'none' : 'flex' }}
                    >
                      <NavLink
                        activeClassName='activeLink'
                        to={ROUTES.ADMIN_DECISIONS}
                      >
                        Administrare monitorizări
                      </NavLink>
                      <NavLink
                        activeClassName='activeLink'
                        to={ROUTES.ADMIN_REPORTS}
                      >
                        Administrare rapoarte
                      </NavLink>
                    </div>
                  </div>
                )}
                <a onClick={handleLogout} className='logout last'>
                  Ieșire
                </a>
              </nav>
            </>
          )}

          {!session && (
            <Link to={ROUTES.LOGIN} className='call-to-action'>
              Autentificare
            </Link>
          )}
        </>
      )}
      {role === types_users.secondary && (
        <>
          <div className='vertical-menu'>
            <Menu
              noOverlay
              customBurgerIcon={<IoIosMenu />}
              customCrossIcon={<IoMdClose />}
              isOpen={isOpen}
              onStateChange={handleOpenMenu}
            >
              {session && (
                <div className='mobileNavWrapper'>
                  <div className='mobileNav'>
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.TUTORIAL}
                    >
                      Tutorial
                    </NavLink>
                    <Space vertical={'2vh'} />
                    {currentUser?.type !== Types.Accounting && (
                      <>
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.LITIGII}
                        >
                          Gestionare litigii
                        </NavLink>
                        <Space vertical={'2vh'} />
                        <NavLink to={ROUTES.LITIGATION_NOTIFICATIONS}>
                          Notificari Litigii
                        </NavLink>
                        <Space vertical={'2vh'} />
                        <NavLink to={ROUTES.CALENDAR}>Calendar termene</NavLink>
                      </>
                    )}
                    {currentUser?.type !== Types.Legal && (
                      <>
                        <Space vertical={'2vh'} />
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.REPORTS}
                        >
                          {!currentUser?.institution.private
                            ? 'Rapoarte de control'
                            : 'Rapoarte de control / Contracte'}
                        </NavLink>
                        <Space vertical={'2vh'} />
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.DECISIONS}
                        >
                          Monitorizări
                        </NavLink>
                        <Space vertical={'2vh'} />
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.NOTIFICATIONS}
                        >
                          Notificări
                        </NavLink>
                        <Space vertical={'2vh'} />
                        {!currentUser?.institution.private && (
                          <>
                            <NavLink
                              onClick={() => setOpenedMenu(false)}
                              to={ROUTES.AUDITS_NOTIFICATIONS}
                            >
                              Audit Curte Conturi
                            </NavLink>
                          </>
                        )}
                      </>
                    )}

                    <Space vertical={'2vh'} />
                    {!currentUser?.institution.private && (
                      <>
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.LEGISLATION}
                        >
                          Legislație
                        </NavLink>
                        <Space vertical={'2vh'} />
                      </>
                    )}

                    {!currentUser?.institution.private && (
                      <>
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.ACHIZITII}
                        >
                          Achiziții publice
                        </NavLink>
                        <Space vertical={'2vh'} />
                      </>
                    )}
                    {!currentUser?.institution.private && (
                      <>
                        <NavLink
                          onClick={() => setOpenedMenu(false)}
                          to={ROUTES.INSTITUTION}
                        >
                          Instituție
                        </NavLink>
                        <Space vertical={'2vh'} />
                      </>
                    )}
                  </div>
                  <a onClick={handleLogout} className='logout last'>
                    Ieșire
                  </a>
                </div>
              )}
              {!session && (
                <>
                  <Link to={ROUTES.LOGIN} className='call-to-action'>
                    Autentificare
                  </Link>
                  <Space vertical={'20vh'} />
                  <Link to='/'>
                    <img src={logo} alt='logo_sirar' />
                  </Link>
                </>
              )}
            </Menu>
          </div>
          <NavLink to='/' className='logo-page'>
            <img src={logo} alt='logo_sirar' />
          </NavLink>

          {session && (
            <>
              <nav>
                <NavLink activeClassName='activeLink' to={ROUTES.TUTORIAL}>
                  Tutorial
                </NavLink>
                <Space vertical={'2vh'} />
                {currentUser?.type !== Types.Accounting && (
                  <>
                    <div
                      className='submenu'
                      onMouseEnter={() => setInternalLitigatonsMenu(true)}
                      onMouseLeave={() => setInternalLitigatonsMenu(false)}
                    >
                      <p className='label'>
                        Litigii <IoIosArrowDown />
                      </p>
                      <div
                        className='list'
                        style={{
                          display: !internalLitigatonsMenu ? 'none' : 'flex'
                        }}
                      >
                        <NavLink
                          activeClassName='activeLink'
                          to={ROUTES.LITIGII}
                        >
                          Gestionare Litigii
                        </NavLink>
                        <NavLink
                          activeClassName='activeLink'
                          to={ROUTES.LITIGATION_NOTIFICATIONS}
                        >
                          Notificari
                        </NavLink>
                        <NavLink
                          activeClassName='activeLink'
                          to={ROUTES.CALENDAR}
                        >
                          Calendar termene
                        </NavLink>
                      </div>
                    </div>
                    <Space vertical={'2vh'} />
                  </>
                )}
                {currentUser?.type !== Types.Legal && (
                  <>
                    <div
                      className='submenu'
                      onMouseEnter={() => setInternalCcrReportsMenu(true)}
                      onMouseLeave={() => setInternalCcrReportsMenu(false)}
                    >
                      <p className='label'>
                        {!currentUser?.institution.private
                          ? 'Rapoarte de control'
                          : 'Rapoarte de control / Contracte'}
                        <IoIosArrowDown />
                      </p>
                      <div
                        className='list'
                        style={{
                          display: !internalCcrReportsMenu ? 'none' : 'flex'
                        }}
                      >
                        <NavLink
                          activeClassName='activeLink'
                          to={ROUTES.REPORTS}
                        >
                          {!currentUser?.institution.private
                            ? 'Rapoarte de control'
                            : 'Rapoarte de control / Contracte'}
                        </NavLink>
                        <NavLink
                          activeClassName='activeLink'
                          to={ROUTES.DECISIONS}
                        >
                          Monitorizari
                        </NavLink>
                        <NavLink
                          activeClassName='activeLink'
                          to={ROUTES.NOTIFICATIONS}
                        >
                          Notificari
                        </NavLink>
                        {!currentUser?.institution.private && (
                          <NavLink
                            activeClassName='activeLink'
                            to={ROUTES.AUDITS_NOTIFICATIONS}
                          >
                            Audit Curte Conturi
                          </NavLink>
                        )}
                      </div>
                    </div>
                    <Space vertical={'2vh'} />
                  </>
                )}
                {!currentUser?.institution.private && (
                  <NavLink activeClassName='activeLink' to={ROUTES.LEGISLATION}>
                    Legislație
                  </NavLink>
                )}
                {!currentUser?.institution.private && (
                  <>
                    <div
                      className='submenu'
                      onMouseEnter={() => setInternalMenu(true)}
                      onMouseLeave={() => setInternalMenu(false)}
                    >
                      <p className='label'>
                        Administrare internă <IoIosArrowDown />
                      </p>
                      <div
                        className='list'
                        style={{
                          display: !internalAdminMenu ? 'none' : 'flex'
                        }}
                      >
                        {(role === types_users.principal ||
                          (role === types_users.secondary &&
                            currentUser?.publicAcquisitions)) && (
                          <NavLink
                            activeClassName='activeLink'
                            to={ROUTES.ACHIZITII}
                          >
                            Achiziții publice
                          </NavLink>
                        )}
                        <NavLink
                          activeClassName='activeLink'
                          to={ROUTES.INSTITUTION}
                        >
                          Instituție
                        </NavLink>
                      </div>
                    </div>
                  </>
                )}
                <a onClick={handleLogout} className='logout last'>
                  Ieșire
                </a>
              </nav>
            </>
          )}

          {!session && (
            <Link to={ROUTES.LOGIN} className='call-to-action'>
              Autentificare
            </Link>
          )}
        </>
      )}

      {role === types_users.admin && (
        <>
          <div className='vertical-menu'>
            <Menu
              noOverlay
              customBurgerIcon={<IoIosMenu />}
              customCrossIcon={<IoMdClose />}
              isOpen={isOpen}
              onStateChange={handleOpenMenu}
            >
              {session && (
                <div className='mobileNavWrapper'>
                  <div className='mobileNav'>
                    <Space vertical={'2vh'} />
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.MANAGE_NOTIFICATIONS}
                    >
                      Notificări
                    </NavLink>
                    <Space vertical={'2vh'} />
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.MANAGE_ACCOUNTS}
                    >
                      Gestionare Conturi
                    </NavLink>
                    <Space vertical={'2vh'} />
                    <NavLink
                      onClick={() => setOpenedMenu(false)}
                      to={ROUTES.MANAGE_LEGISLATION}
                    >
                      Legislație
                    </NavLink>
                  </div>
                  <a onClick={handleLogout} className='logout last'>
                    Ieșire
                  </a>
                </div>
              )}
              {!session && (
                <>
                  <Link to={ROUTES.LOGIN} className='call-to-action'>
                    Autentificare
                  </Link>

                  <Space vertical={'20vh'} />
                  <Link to='/'>
                    <img src={logo} alt='logo_sirar' />
                  </Link>
                </>
              )}
            </Menu>
          </div>
          <NavLink to='/' className='logo-page'>
            <img src={logo} alt='logo_sirar' />
          </NavLink>

          {session && (
            <>
              <nav>
                <NavLink
                  activeClassName='activeLink'
                  to={ROUTES.MANAGE_NOTIFICATIONS}
                >
                  Notificări
                </NavLink>
                <Space vertical={'2vh'} />
                <NavLink
                  activeClassName='activeLink'
                  to={ROUTES.MANAGE_ACCOUNTS}
                >
                  Gestionare Conturi
                </NavLink>
                <Space vertical={'2vh'} />
                <NavLink
                  activeClassName='activeLink'
                  to={ROUTES.MANAGE_LEGISLATION}
                >
                  Legislație
                </NavLink>

                {/* <Link to={ROUTES.HOME} className='last'> */}
                <a onClick={handleLogout} className='logout last'>
                  Ieșire
                </a>
                {/* </Link> */}
              </nav>
            </>
          )}

          {!session && (
            <Link to={ROUTES.LOGIN} className='call-to-action'>
              Autentificare
            </Link>
          )}
        </>
      )}
    </header>
  );
};

export default Header;
